import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'describeCron',
  standalone: true,
})
export class DescribeCronPipe implements PipeTransform {
  private readonly DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  private readonly MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
                              'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  transform(expr: string): string {
    if (!expr) return '';
    const parts = expr.trim().split(/\s+/);
    if (parts.length !== 5) return '';

    const [min, hour, dom, month, dow] = parts;
    const isWild = (v: string) => v === '*';
    const isStep = (v: string) => v.startsWith('*/');
    const stepN = (v: string) => v.slice(2);

    const dateCtx = (): string => {
      if (!isWild(dow)) {
        const days = dow.split(',').map(d => this.DAYS[+d] ?? d).join(', ');
        return `Her ${days}`;
      }
      if (!isWild(dom) && !isWild(month)) {
        return `Her yıl ${dom} ${this.MONTHS[+month - 1] ?? month}`;
      }
      if (!isWild(dom)) return `Her ayın ${dom}. günü`;
      if (!isWild(month)) return `Her yıl ${this.MONTHS[+month - 1] ?? month} ayında`;
      return '';
    };

    const date = dateCtx();
    const d = !!date;

    if (isStep(min) && isWild(hour)) {
      const freq = d ? `${stepN(min)} dakikada bir` : `Her ${stepN(min)} dakikada bir`;
      return d ? `${date}, ${freq}` : freq;
    }

    if (isStep(hour)) {
      const freq = d ? `${stepN(hour)} saatte bir` : `Her ${stepN(hour)} saatte bir`;
      const offset = (!isWild(min) && !isStep(min) && min !== '0') ? `, ${min}. dakikada` : '';
      return d ? `${date}, ${freq}${offset}` : `${freq}${offset}`;
    }

    if (isWild(hour)) {
      const freq = isWild(min) ? (d ? 'her dakika' : 'Her dakika')
        : min === '0' ? (d ? 'saat başı' : 'Her saat başı')
        : d ? `saatin ${min}. dakikasında` : `Her saatin ${min}. dakikasında`;
      return d ? `${date}, ${freq}` : freq;
    }

    const time = `saat ${hour.padStart(2, '0')}:${min.padStart(2, '0')}`;
    return d ? `${date} ${time}` : `Her gün ${time}`;
  }
}
